module.exports = __webpack_public_path__ + "static/media/write.06006655.svg";